import React, { useState } from 'react';
import { Row } from './Layout';

interface StreamCardProps {
    stream: any;
    onClick: (stream: any) => void;
}

export const StreamCard: React.FC<StreamCardProps> = ({ stream, onClick }) => {
    const [hov, setHov] = useState(false);

    return (
        <div onClick={() => onClick(stream)}
            onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
            style={{
                background: `linear-gradient(135deg,${stream.thumb},#0F0F18)`, borderRadius: 18,
                overflow: 'hidden', cursor: 'pointer',
                border: `1px solid ${hov ? stream.accent + '44' : 'var(--border)'}`,
                transition: 'all .3s', transform: hov ? 'translateY(-3px)' : 'none',
                boxShadow: hov ? `0 14px 36px ${stream.accent}22` : 'none'
            }}>
            <div style={{
                height: 106, position: 'relative',
                background: `radial-gradient(circle at 30% 30%,${stream.accent}33,transparent 70%)`
            }}>
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 38 }}>{stream.avatar}</div>
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 45, background: `linear-gradient(to top,${stream.thumb}ee,transparent)` }} />
                <div style={{ position: 'absolute', top: 8, left: 8 }}><span className="live-badge"><span className="dot-live" />CANLI</span></div>
                {stream.audio && (
                    <div style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,.5)', borderRadius: 6, padding: '3px 6px', display: 'flex', gap: 2, alignItems: 'flex-end' }}>
                        {[1, 2, 3, 2, 1].map((h, i) => <div key={i} style={{ width: 3, borderRadius: 2, background: stream.accent, animation: `waveBar ${.5 + i * .1}s ease-in-out ${i * .08}s infinite` }} />)}
                    </div>
                )}
            </div>
            <div style={{ padding: '9px 11px' }}>
                <div className="syne" style={{ fontSize: 11, fontWeight: 700, marginBottom: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{stream.topic}</div>
                <Row style={{ justifyContent: 'space-between' }}>
                    <Row style={{ gap: 5 }}>
                        <div style={{ width: 18, height: 18, borderRadius: 5, background: `${stream.accent}33`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10 }}>{stream.avatar}</div>
                        <span style={{ fontSize: 10, color: 'var(--muted)' }}>{stream.name}</span>
                    </Row>
                    <span style={{ fontSize: 10, color: stream.accent, fontWeight: 600 }}>👁 {stream.viewers}</span>
                </Row>
            </div>
        </div>
    );
};
